import CasualChattingIcon from './icons/casual_chatting.svg?react';
import DeepConnectionIcon from './icons/deep_connection.svg?react';
import ExploringWithoutExpectationsIcon from './icons/exploring_without_expectations.svg?react';
import FriendshipIcon from './icons/friendship.svg?react';
import LongTermRelationshipIcon from './icons/long_term_relationship.svg?react';
import OneNightStandIcon from './icons/one_night_stand.svg?react';
import { IdealMatchOptionsType } from './types';

export const IDEAL_MATCH_OPTIONS: IdealMatchOptionsType = [
  {
    id: 'deep_connection',
    title: 'Deep connection',
    icon: DeepConnectionIcon,
  },
  {
    id: 'friendship',
    title: 'Friendship',
    icon: FriendshipIcon,
  },
  {
    id: 'one_night_stand',
    title: 'One night stand',
    icon: OneNightStandIcon,
  },
  {
    id: 'casual_chatting',
    title: 'Casual chatting',
    icon: CasualChattingIcon,
  },
  {
    id: 'long_term_relationship',
    title: 'Long term relationship',
    icon: LongTermRelationshipIcon,
  },
  {
    id: 'exploring_without_expectations',
    title: 'Exploring without expectations',
    icon: ExploringWithoutExpectationsIcon,
  },
];
